import { Injectable } from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {Observable} from "rxjs";
import {environment} from "../../../environments/environment";
import {Hotspot} from "../../model/Hotspot";
import {HotspotDotLink} from "../../model/HotspotDotLink";
import {map} from "rxjs/operators";
import {HotspotDotLinkRaw} from "../../model/HotspotDotLinkRaw";
import {Disclaimer} from '../../model/Disclaimer';
import {LoadHotspotResponse} from '../../model/LoadHotspotResponse';

@Injectable({
  providedIn: 'root'
})
export class HotspotCreatorService {

  urlHotspotCreator: string = '/hotspot-creator';

  constructor(private http: HttpClient) { }

  public getHotspotsForPackage(packageId): Observable<any> {
    return this.http.get<Hotspot>(`${environment.packagesManagerBackendUrl}` + this.urlHotspotCreator + '/hotspots/' + packageId);
  }

  public deleteHotspotOfPackage(pkgId: number, hotspotId: number): Observable<any> {
    return this.http.delete(`${environment.packagesManagerBackendUrl}` + this.urlHotspotCreator + '/hotspot/' + pkgId + '/' + hotspotId);
  }

  public addHotspotToPackage(pkgId: number, hotspotTitle: string): Observable<any> {
    return this.http.post(`${environment.packagesManagerBackendUrl}` + this.urlHotspotCreator + '/hotspot/add/' + pkgId, {'new-hotspot-title': hotspotTitle});
  }

  public renameHotspotForPackage(pkgId: number, hotspotId: number, updatedHotspotTitle: any): Observable<any> {
    return this.http.put(`${environment.packagesManagerBackendUrl}` + this.urlHotspotCreator + '/hotspot/' + pkgId + '/' + hotspotId,
      updatedHotspotTitle);
  }

  public getHotspotDot(packageId, hotspotId): Observable<any> {
    return this.http.get<Hotspot>(`${environment.packagesManagerBackendUrl}` + this.urlHotspotCreator + '/hotspot-dots/' + packageId + '/' + hotspotId);
  }

  public deleteHotspotDot(pkgId: number, hotspotId: number, dotId: number): Observable<any> {
    return this.http.delete(`${environment.packagesManagerBackendUrl}` + this.urlHotspotCreator + '/hotspot-dot/' + pkgId + '/' + hotspotId + '/' + dotId);
  }

  public addDotToHotspotImage(pkgId: number, hotspotId: number, hotspotDot: any): Observable<any> {
    return this.http.post(`${environment.packagesManagerBackendUrl}` + this.urlHotspotCreator + '/hotspot-dot/add/' + pkgId + '/' + hotspotId, hotspotDot);
  }

  public updateHotspotDot(pkgId: number, hotspotId: number, dotId: number, updatedHotspotDot: any): Observable<any> {
    return this.http.put(`${environment.packagesManagerBackendUrl}` + this.urlHotspotCreator + '/hotspot-dot/update/' + pkgId + '/' + hotspotId + '/' + dotId,
      updatedHotspotDot);
  }

  public getHotspotDotLinks(pkgId: number): Observable<any> {
    return this.http.get<Hotspot>(`${environment.packagesManagerBackendUrl}` + '/transform/toc/' + pkgId);
  }

  public uploadHotspotTemplate(pkgId: number, hotspotId: number, hotspotTemplateName: string): Observable<any> {
    return this.http.get<Hotspot>(`${environment.packagesManagerBackendUrl}` + '/hotspot-template/save/' + pkgId + '/' + hotspotId + '/' + hotspotTemplateName);
  }

  public getHotspotTemplateList(): Observable<any> {
    return this.http.get<any[]>(`${environment.packagesManagerBackendUrl}` +'/hotspot-template/loadtemplatelist/' );
  }

  public loadTemplateAndCheckBaseIds(pkgId: number, hotspotTemplateName: string): Observable<LoadHotspotResponse[]> {
    return this.http.get<LoadHotspotResponse[]>(`${environment.packagesManagerBackendUrl}` + '/hotspot-template/checkbaseid/' + pkgId + '/' + hotspotTemplateName);
  }

  public loadTemplate(pkgId: number, hotspotTemplateName: string): Observable<Hotspot> {
    return this.http.get<Hotspot>(`${environment.packagesManagerBackendUrl}` + '/hotspot-template/add/' + pkgId + '/' + hotspotTemplateName);
  }

  public deleteHotspotTemplate(hotspotTemplateName: string): Observable<any> {
    return this.http.delete(`${environment.packagesManagerBackendUrl}` + '/hotspot-template/delete/' + hotspotTemplateName);
  }

  // public getTocIfNotPresent(pkgId: number): Observable<any> {
  //   return this.http.get<Hotspot>(`${environment.packagesManagerBackendUrl}` + '/transform/toc/' + pkgId);
  // }
  //
  // public getHotspotDotLinks(packageId): Observable<HotspotDotLink[]> {
  //   return this.http.get<HotspotDotLinkRaw[]>(
  //     `${environment.packagesManagerBackendUrl}` + '/package/download/toc/' + packageId
  //   ).pipe(
  //     map((raws: HotspotDotLinkRaw[]) => this.provideHotspotDotLinksFromRaw(raws))
  //   );
  // }
  //
  // provideHotspotDotLinksFromRaw(raws: HotspotDotLinkRaw[]): HotspotDotLink[] {
  //   return raws.map(raw =>
  //     {
  //       return new HotspotDotLink(
  //       raw.id,
  //       raw.title,
  //       raw.link,
  //       raw.file,
  //       raw.hasImage,
  //       raw.hasLink,
  //       raw.children
  //       );
  //     }
  //   );
  // }
}
